// extracted by mini-css-extract-plugin
export var numberInputContainer = "_3z-0";
export var startPickingButton = "_3z-1";